import {formatBusinessTimestamp} from 'src/api/business-time'

export function stintDatesLabel(deployedAt: Date, returnedAt?: Date | null): string {
    const start = formatBusinessTimestamp(deployedAt, 'MMM d, yyyy')
    if (!returnedAt) {
        return `On site since ${start}`
    }

    const end = formatBusinessTimestamp(returnedAt, 'MMM d, yyyy')
    if (start === end) {
        return start
    }

    const sameYear =
        formatBusinessTimestamp(deployedAt, 'yyyy') === formatBusinessTimestamp(returnedAt, 'yyyy')
    return sameYear
        ? `${formatBusinessTimestamp(deployedAt, 'MMM d')} – ${end}`
        : `${start} – ${end}`
}

export function stintTimesTitle(deployedAt: Date, returnedAt?: Date | null): string | undefined {
    const times = [deployedAt, ...(returnedAt ? [returnedAt] : [])]
    if (times.every((value) => formatBusinessTimestamp(value, 'HH:mm') === '00:00')) {
        return undefined
    }

    const pattern = 'MMM d, yyyy h:mm a'
    const start = formatBusinessTimestamp(deployedAt, pattern)
    return returnedAt
        ? `${start} – ${formatBusinessTimestamp(returnedAt, pattern)}`
        : `Since ${start}`
}
